interface Locales {
    [language: string]: {
        code: string;
        display_name: string;
        full_name: string;
        dir: string;
    };
}

const fallbacklLanguage = {
    'en-US': {
        code: 'en-US',
        display_name: 'En',
        full_name: 'English',
        dir: 'ltr',
    },
};

export const rtlLanguages = ['ar', 'arc', 'dv', 'fa', 'ha', 'he', 'khw', 'ks', 'ku', 'ps', 'ur', 'yi'];

export const isRtlLanguage = (lng: string) => rtlLanguages.some((l) => l === lng);

export const getLanguageDirection = (lng: string) => (isRtlLanguage(lng) ? 'rtl' : 'ltr');

const localStorageLocales = localStorage.getItem('locales');
export const locales: Locales =
    (localStorageLocales && JSON.parse(localStorageLocales)) ||
    (import.meta.env.REACT_APP_I18N_LNG_LIST && JSON.parse(import.meta.env.REACT_APP_I18N_LNG_LIST)) ||
    fallbacklLanguage;

export const localesCodeMap = Object.keys(locales).map((key) => locales[key].code);

export const defaultI18Lng = import.meta.env.REACT_APP_I18N_DEFAULT_LNG || 'en-US';
